export default class mobileMenu {
	constructor() {
		this.container = document.querySelector('.header-mobile');
		if (!this.container) return;
		this.button = this.container.querySelector('.js-mobile-menu-toggle');
		if (!this.button) return;
		this.menu = this.container.querySelector('.js-mobile-menu');
		if (!this.menu) return;

		this.bindEvents();
	}
	bindEvents() {
		document.addEventListener('keydown', (event) => {
			if (event.key !== 'Escape') return;
			this.close();
		});
		this.button.addEventListener('click', event => {
			this.toggle();
		});
	}
	open() {
		this.container.classList.toggle('is-active');
		this.button.setAttribute('aria-expanded', true);
	}
	close() {
		this.container.classList.remove('is-active');
		this.button.setAttribute('aria-expanded', false);
	}
	toggle() {
		this.container.classList.toggle('is-active');
		this.button.setAttribute('aria-expanded', true);
	}
}
